import {Tooltip} from '@material-ui/core'
import {action, autorun, computed, runInAction} from 'mobx'
import {Icon, IconName, MaybeElement, MenuItem, TextProps} from '@blueprintjs/core'
import {TooltipProps} from '@material-ui/core/Tooltip/Tooltip'
import {Collections, Dashboard, DesktopMacOutlined, EuroOutlined, InsertPhoto, ListAltOutlined, LocalLibrary, Palette} from '@material-ui/icons'
import {synchronizeStores} from '@stores/SynchronizeStores'
import {AddIcon, AddManyIcon, CentricLogo, PdfSvgIcon, YenIcon} from './'
import {ICatalogFieldConfig, GlobalDeploymentSettings, deployments, CatalogInstanceChildStore, CatalogStore} from '@stores'
import {DEFAULT_DEPLOYMENT_SETTINGS} from './'
import { _, observable, React} from '@api'

export const IMAGE = 'image'

export class UIStore {
  constructor() {
    synchronizeStores(() => {
      autorun(() => {
        const deploymentSettings = deployments?.deploymentConfig?.settings
        runInAction(() => {
          this.settings = _.merge({}, DEFAULT_DEPLOYMENT_SETTINGS, this.settings, deploymentSettings)
        })
      }, {name: `Setup ui settings from configuration + defaults`})
    })
  }

  @observable publicUrl = process.env.PUBLIC_URL

  @observable settings: GlobalDeploymentSettings = DEFAULT_DEPLOYMENT_SETTINGS

  @computed get defaultCatalogFieldBehavior(): { group: boolean, filter: boolean, sort: boolean, editable?: boolean } {
    const {settings: {defaults: {catalog: {fieldBehavior}}}} = this
    return {
      group: fieldBehavior?.all || fieldBehavior?.group || false,
      filter: fieldBehavior?.all || fieldBehavior?.filter || false,
      sort: fieldBehavior?.all || fieldBehavior?.sort || false,
      editable: fieldBehavior?.all || fieldBehavior?.editable || false
    }
  }

  constants = {
    VALID_IMAGE_EXTENSION: ['png', 'jpg', 'jpeg'],
    REORDER: 'REORDER',
    UPLOAD: 'UPLOAD'
  }

  @observable private _language: string

  @action setLang = (l: string) => {
    this._language = l
  }

  @computed get language(): string {
    const {deploymentConfig} = deployments,
      language = this._language ?? window.navigator.language

    if (deploymentConfig?.languages) {
      const {languages} = deploymentConfig
      const found = languages.find(l => l.language == language)
      if (found) {
        return language
      } else {
        return _.first(languages).language
      }
    }

    return language ?? 'en-US'
  }

  labelForField = (field: ICatalogFieldConfig, tense: 'singular' | 'plural' = 'singular') => {
    return field.label ?? field?.def?.displayName[tense] ?? field.field
  }

  iconForCurrency(currency: string, props: { className?: string } = {}) {
    if (!currency) return null
    switch (currency?.toLowerCase()) {
      case 'yen':
        return <YenIcon className={classNames(props?.className, 'bp3-icon')}/>

      case 'usd':
        return <Icon iconSize={14} icon={'dollar'} {...props} />

      case 'eur':
        return <EuroOutlined {...props} />
      default:
        if (currency) console.warn(`Unhandled currency '${currency}'`)
        return null
    }
  }

  htmlForCurrency = (currency: 'usd' | 'yen' | string | undefined) => {
    switch (currency) {
      case 'usd':
        return '$'
      case 'yen':
        return '¥'
      case 'eur':
        return '€'

    }

    return ''
  }
}

import {Popover} from '@blueprintjs/core'
import {Popover2, Tooltip2} from '@api'
import classNames from 'classnames'

export const ui = new UIStore()
const {settings} = ui
Popover.defaultProps.hoverOpenDelay = settings.HOVER_TIMEOUT
Popover.defaultProps.hoverCloseDelay = settings.HOVER_TIMEOUT
Popover2.defaultProps.hoverOpenDelay = settings.HOVER_TIMEOUT
Popover2.defaultProps.hoverCloseDelay = settings.HOVER_TIMEOUT
MenuItem.defaultProps.popoverProps = {hoverCloseDelay: settings.HOVER_TIMEOUT}
MenuItem.defaultProps.multiline = true // Otherwise massive perf penalties as they measure for ... which causes reflow

/**
 * This is for performance, otherwise on any resize all the popovers will try and detect if they need to move - super expensive
 */
// Popover2.defaultProps.modifiers = Tooltip2.defaultProps.modifiers = {
//   preventOverflow: {
//     enabled: false
//   },
//   flip: {
//     enabled: false
//   }
// }

Tooltip['defaultProps'] = Object.assign({}, Tooltip['defaultProps'], {enterDelay: settings.HOVER_TIMEOUT} as Partial<TooltipProps>)
Tooltip2.defaultProps = Object.assign({}, Tooltip2['defaultProps'], {
  hoverOpenDelay: settings.HOVER_TIMEOUT
  // modifiers: {
  //   arrow: {
  //     enabled: false,
  //   },
  //   offset: {
  //     options: {
  //       offset: [0, 5]
  //     },
  //   },
  // }
} as Partial<TooltipProps>)
//_.merge(Tooltip2.defaultProps.modifiers, { arrow: {enabled: false}})
//Tooltip2.defaultProps.modifiers = {arrow: {enabled: false}}

import {Text} from '@blueprintjs/core'

Text['defaultProps'] = Object.assign({}, Text['defaultProps'], {
  ellipsize: false
} as Partial<TextProps>)


// WEBPACK FOOTER //
// ./src/stores/ui/UIStore.tsx